import SLPInfluencersWhy1 from '../../assets/slpInfluencers/slpInfluencersWhy1.png';
import SLPInfluencersWhy2 from '../../assets/slpInfluencers/slpInfluencersWhy2.png';
import SLPInfluencersWhy3 from '../../assets/slpInfluencers/slpInfluencersWhy3.png';
import SLPInfluencersListPersonaBtn from './SLPInfluencersListPersonaBtn';
import * as CommonSectionTypes from '../components/CommonSectionLayout/CommonSectionTypes';
import CommonSectionGenerator from '../components/CommonSectionLayout/CommonSectionGenerator';

const subSection1: CommonSectionTypes.SubSection =
{
  heading: 'Skip the Shoots — or Don\'t. Your Call.',
  description: 'Generate brand content from your Persona using FairGen AI Studio, or produce traditional UGC content yourself. We support both — whichever fits the brand\'s brief and your workflow.',
  images: [SLPInfluencersWhy3]
};

const subSection2: CommonSectionTypes.SubSection =
{
  heading: 'Earn Passively From Brand Campaigns',
  description: 'Get paid when your Persona is used in ads, creative projects, mock-ups, and UGC creator endorsements.',
  images: [SLPInfluencersWhy2]
};

const subSection3: CommonSectionTypes.SubSection =
{
  heading: 'Total Control Over Your Persona',
  description: 'Set your own terms, pricing, and approvals.<br/>Nothing goes live without your sign-off.',
  images: [SLPInfluencersWhy1]
};

const slpInfluencersWhyData: CommonSectionTypes.Section =
{
  heading: 'Why Saagas for UGC Creators?',
  subheading: 'Monetize Your Digital Identity - Securely and On Your Terms',
  subsections: [subSection1, subSection2, subSection3]
};

const SLPInfluencersWhy = () =>
{
  return CommonSectionGenerator(slpInfluencersWhyData, SLPInfluencersListPersonaBtn, '#151515');
};

export default SLPInfluencersWhy;
